import {useState, useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import clsx from 'clsx'
import {useDispatch} from 'react-redux'
import {useLayout} from '../../core'
import {toAbsoluteUrl} from '../../../helpers'
import {AsideTabs, findTab} from './AsideTabs'
import {AsideFooter} from './AsideFooter'
import {TabsBase} from './Tabs/_TabsBase'
import {getUserDetails} from '../../../../redux/actions/user'
import './healon-aside.css'

const MINIMIZE_ATTR = 'data-kt-aside-minimize'

const AsideDefault = () => {
  const dispatch = useDispatch()
  const {config, classes} = useLayout()
  const {pathname} = useLocation()
  const [link, setLink] = useState(pathname)
  const [panelOpen, setPanelOpen] = useState(!config.aside.minimized)

  useEffect(() => {
    dispatch(getUserDetails())
  }, [dispatch])

  // Keep the active module in sync when navigation happens outside the sidebar.
  useEffect(() => {
    if (findTab(pathname)) setLink(pathname)
  }, [pathname])

  // Metronic's layout CSS reads this body attribute to size the wrapper.
  useEffect(() => {
    if (panelOpen) document.body.removeAttribute(MINIMIZE_ATTR)
    else document.body.setAttribute(MINIMIZE_ATTR, 'on')
  }, [panelOpen])

  const selectModule = (next) => {
    const isSame = findTab(link)?.link === next
    setLink(next)
    setPanelOpen((open) => (isSame ? !open : true))
  }

  const activeTab = findTab(link)

  return (
    <div
      id='kt_aside'
      className={clsx('aside aside-extended hl-aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width='auto'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      {/* begin::Primary */}
      <div className='aside-primary hl-aside-primary'>
        <Link to='/oms' className='hl-aside-logo' id='kt_aside_logo'>
          <img
            src={toAbsoluteUrl('/media/logos/healon-wordmark.png')}
            alt='HealOn'
            className='hl-logo-full'
          />
          <img
            src={toAbsoluteUrl('/media/logos/healon-icon.png')}
            alt='HealOn'
            className='hl-logo-mark'
          />
        </Link>

        <AsideFooter />

        <div className='hl-nav-scroll' id='kt_aside_nav'>
          <AsideTabs link={link} onSelect={selectModule} />
        </div>
      </div>
      {/* end::Primary */}

      {config.aside.secondaryDisplay && (
        <div className={clsx('aside-secondary hl-aside-panel', {'is-collapsed': !panelOpen})}>
          <div className='aside-workspace hl-aside-workspace' id='kt_aside_wordspace'>
            <button
              type='button'
              className='hl-panel-collapse'
              onClick={() => setPanelOpen(false)}
              title={`Collapse ${activeTab?.tooltip || 'menu'}`}
              aria-label='Collapse menu'
            >
              <span className='material-symbols-rounded'>left_panel_close</span>
            </button>
            <TabsBase link={link} />
          </div>
        </div>
      )}
    </div>
  )
}

export {AsideDefault}
